export default {
    name: 'modalMixin',
    methods: {
        onClose(){
            this.$emit('modalClosed');
        },
    },
    mounted() {
        $('body').addClass('modal-open');
    },
    destroyed(){
        $('body').removeClass('modal-open');
    },
}



// WEBPACK FOOTER //
// ./src/components/common/modal-mixin.js